import isEqual from "lodash/isEqual";
import type { GroupedToolCall } from "./group-tool-messages";
import { doesHumanInTheLoopActionMatchToolCall } from "./human-in-the-loop";
import { parseToolArgs } from "./messages/tool-call-presentation";
import type { PendingToolReview } from "./PendingToolReviewScope";

export const matchPendingReviewsToCalls = (
  calls: GroupedToolCall[],
  reviews: PendingToolReview[],
  hasResult: (callId: string) => boolean
) => {
  const matches = new Map<string, string>();
  const used = new Set<string>();
  reviews.forEach((review) => {
    if (!review.key || !review.action) return;
    const call = calls.find(
      ({ id, toolCall }) =>
        !used.has(id) &&
        !hasResult(id) &&
        doesHumanInTheLoopActionMatchToolCall(
          review.action!.name,
          toolCall.name ?? ""
        ) &&
        isEqual(review.action!.args, parseToolArgs(toolCall.args))
    );
    if (call) {
      used.add(call.id);
      matches.set(call.id, review.key);
    }
  });
  return matches;
};
